import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const getParticularsubadminAPI = createAsyncThunk(
  "auth/subadmin/getPaticular",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.get(
        apiRoutes.subadminAction("details",1,id,1)
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" };
const getparticularDetailssubadminSlice = createSlice({
  name: "get particular subadmin",
  initialState: { result: [], loading: false, error: null, message: "" },
  reducers: {
    resetgetparticularsubadmin: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getParticularsubadminAPI.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getParticularsubadminAPI.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(getParticularsubadminAPI.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetgetparticularsubadmin } = getparticularDetailssubadminSlice.actions;
export const getparticularDetailssubadminReducer =
  getparticularDetailssubadminSlice.reducer;
